module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-flat-screen5@2x-4022faf24b9073829a15e45a02127737.png";